import { JobTimeTrackingService } from "../time-tracking/job-time-tracking-modal/job-time-tracking.service";
import { Observable, Subscription } from "rxjs";
import { LocalStorageService } from "src/app/utils/localstorage.service";

import { Router, ActivatedRoute } from "@angular/router";
import { JobsStore } from "../jobs.store";
import { JobsService } from "../jobs.service";
import { Conversation } from "../../../../conversations/panels/conversation.model";
import { Job, TaskGroup } from "../job.model";
import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
  HostListener,
  ElementRef,
  OnDestroy,
  DestroyRef,
  inject,
} from "@angular/core";
import { AccountantService } from "../../accountant.service";
import moment from "moment";
import * as _ from "underscore";

import { environment } from "../../../../../../environments/environment";

import { HotToastService } from "@ngneat/hot-toast";
import { TelemetryService } from "src/app/dashboard/telemetry.service";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FilesManagerService } from "src/app/dashboard/files-manager/files-manager.service";
import { WorkspacesService } from "../../workspaces.service";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { RealTimeService } from "../../../common/notifications/real-time.service";
import { AutosizeModule } from "ngx-autosize";
import { EmailCardComponent } from "../../../../email/email-card/email-card.component";
import { NotesComponent } from "../../notes/notes.component";
import { PinnedPanelComponent } from "../../pinned-panel/pinned-panel.component";
import { JobsAndTasksCardComponent } from "../jobs-and-tasks-card/jobs-and-tasks-card.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgClass } from "@angular/common";
import { PaidOverlayDirective } from "../../../../paid-overlay.directive";
import { Editor } from "primeng/editor";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

declare var jQuery: any;

@Component({
  selector: "app-jobs-and-tasks",
  templateUrl: "./jobs-and-tasks.component.html",
  styleUrls: ["./jobs-and-tasks.component.scss"],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PaidOverlayDirective,
    TooltipModule,
    BsDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    TypeaheadModule,
    NgClass,
    JobsAndTasksCardComponent,
    PinnedPanelComponent,
    NotesComponent,
    EmailCardComponent,
    AutosizeModule,
  ],
})
export class JobsAndTasksComponent implements OnInit, OnDestroy {
  _conversation: Conversation;
  public saveInterval: number = 500;
  dataSubs = new Subscription();
  data: any;
  history: any = [];
  sortBy: string = "due_date";
  sortByLabel: string = "Due Date";

  templates = [];
  templatesCtrl = new UntypedFormControl();

  duplicateSelectedObj: Job;

  templatesForm = new UntypedFormGroup({
    templates: this.templatesCtrl,
  });

  @Input() templateManager: boolean = false;

  _company = { notes: "", id: null, uuid: "" };

  /* should show right panel or not */
  showJobModal = false;

  job: Job = <Job>{};
  imageUploadUrl = `${environment.apiUrl}/file-manager/`;
  start = 0;

  loading = true;
  emailsLoading = false;
  modalRef: BsModalRef;

  @ViewChild("rte") public rte: Editor;

  aiJobDescription = "";
  jobQuestion = "";

  emails: [];

  @ViewChild("templateListInput") public templateListInput: ElementRef;
  jobAnswer: any;

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return true;
  }

  private subscriptions = new Subscription();
  readonly destroyRef = inject(DestroyRef);

  // Flags to track the visibility state of each panel
  isPanelJobsHidden = false;
  isPanelEmailHidden = false;

  constructor(
    public jobsService: JobsService,
    public jobsStore: JobsStore,
    private router: Router,
    private route: ActivatedRoute,
    private accountantService: AccountantService,
    private localStorage: LocalStorageService,
    private filesManagerService: FilesManagerService,
    private cdr: ChangeDetectorRef,
    private toastr: HotToastService,
    private modalService: BsModalService,
    private jobTimeTrackingService: JobTimeTrackingService,
    private workspacesService: WorkspacesService,
    public sharedDataService: SharedDataService,
    private dashboardService: DashboardService,
    private dashboardStore: DashboardStore,
    private realTimeService: RealTimeService,
  ) {
    // cdr.detach(); // deactivate change detection
    // setInterval(() => {
    //   this.cdr.detectChanges();
    //   // manually trigger change detection
    // }, 250);
  }

  ngOnInit(): void {
    if (this.sharedDataService.subscriptionType == "free") {
      this.loading = false;
      return;
    }

    this.jobsStore.notifyJobDeleted.subscribe((jobUuid) => {
      this.jobsStore.jobs[this.jobsStore.activeTab] = this.jobsStore.jobs[
        this.jobsStore.activeTab
      ].filter((j) => {
        return j.uuid != jobUuid;
      });
      this.cdr.detectChanges();
    });

    this.jobsStore.reloadJobs$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loading = true;
        this.jobsService
          .getJobsByStatus(
            this._company.id,
            this.jobsStore.activeTab,
            this.start,
            this.sortBy,
          )
          .subscribe((res) => {
            this.jobsStore.jobs[this.jobsStore.activeTab] = <Array<Job>>(
              res.jobs
            );

            this.loading = false;
            this.cdr.detectChanges();
          });
      });

    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.job != null) {
        this.jobsStore.jobs[this.jobsStore.activeTab].forEach((j) => {
          if (j.uuid == queryParams.job) {
            // j["selected"] = true;
            this.selectJob(j);
          }
        });
      }
    });

    this.workspacesService.$conversation
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((conversation) => {
        this._conversation = conversation;
      }),
      this.workspacesService.$company
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((company) => {
          if (company != null && this._company.id != company.id) {
            this._company = company;

            // Reset the pagination(?) param on the job list
            this.start = 0;
            this.emails = [];

            this.jobsStore.resetJobs();
            this.dataSubs.unsubscribe();
            this.jobsStore.activeTab = "current";

            if (this._company.id != null && this._company.id != "undefined") {
              this.loading = true;
              this.cdr.detectChanges();
              this.dataSubs = this.jobsService
                .getJobsByStatus(
                  this._company.id,
                  this.jobsStore.activeTab,
                  this.start,
                  this.sortBy,
                )
                .subscribe((res) => {
                  this.jobsStore.jobs[this.jobsStore.activeTab] = <Array<Job>>(
                    res.jobs
                  );

                  this.realTimeService.setConversationUpdatesListener(
                    this._company["company_conversation"].uuid,
                  );

                  if (
                    this.jobsStore.jobs[this.jobsStore.activeTab].length > 0 &&
                    this.route.snapshot.queryParams.job == null
                  ) {
                    // document
                    //   .getElementById("jobs-tab")
                    //   .classList.remove("component-loading"); // remove loading
                    // Uncomment this to mark job as selected when the page loads
                    // this.selectJob(this.jobsStore.jobs["current"][0]);
                  } else {
                    this.jobsStore.jobs[this.jobsStore.activeTab].forEach(
                      (j) => {
                        if (j.uuid == this.route.snapshot.queryParams.job) {
                          this.selectJob(j);
                        }
                      },
                    );

                    // document
                    //   .getElementById("jobs-tab")
                    //   .classList.remove("component-loading"); // remove loading
                  }

                  this.loading = false;
                  this.cdr.detectChanges();
                });

              if (this.sharedDataService.subscriptionType == "premium") {
                this.getEmails();
                this.cdr.detectChanges();
              }
            }

            this.showJobModal = false;
          }
        }),
      // Listener to push a new job when created from other functions, like recurring ones

      this.jobsService.newRecurringJob
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((job: Job) => {
          if (
            this.jobsStore.jobs.current.filter((j) => {
              return j.uuid == job.uuid;
            }).length == 0
          ) {
            this.jobsStore.jobs.current.push(job);

            // Add this to remove the completed jobs from the current list
            this.jobsStore.jobs.current = this.jobsStore.jobs.current.filter(
              (j) => {
                return j.status != 3;
              },
            );

            this.cdr.detectChanges();
          }
        }),
      // Listener to mark a job as selected coming from other functions, like deleting and duplicating

      this.jobsStore.changeSelectedJob
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((sub) => {
          this.selectJob(sub);
        }),
      this.jobsService
        .getJobTemplates("all")
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((res) => {
          this.templates = <Array<Job>>res.jobs;
        });
  }

  ngOnDestroy() {}

  switchJobsTabs(tab): void {
    this.loading = true;
    this.cdr.detectChanges();
    this.jobsStore.activeTab = tab;
    this.dataSubs.unsubscribe();
    this.jobsStore.jobs[this.jobsStore.activeTab] = [];

    this.start = 0;

    this.dataSubs = this.jobsService
      .getJobsByStatus(this._company.id, tab, this.start, this.sortBy)
      .subscribe((res) => {
        this.jobsStore.jobs[this.jobsStore.activeTab] = <Array<Job>>res.jobs;
        this.cdr.detectChanges();

        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  getJobsWithSortBy(sort_by): void {
    this.loading = true;
    this.cdr.detectChanges();
    this.jobsService
      .getJobsByStatus(
        this._company.id,
        this.jobsStore.activeTab,
        this.start,
        sort_by,
      )
      .subscribe((res) => {
        this.jobsStore.jobs[this.jobsStore.activeTab] = <Array<Job>>res.jobs;
        this.cdr.detectChanges();
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  selectJob(job: Job) {
    if (this.job.task_groups != null) {
      this.job.task_groups = this.job.task_groups.filter(
        (tg) => tg.uuid.length > 10 && tg.name != "",
      );
    }

    this.cdr.detectChanges();
    /* This timeout exists to handle the blur() delay
    Fixes a bug that happened when an input was selected and
    another job was selected, causing the information of the last one
    to override the newly selected because of the blur() timing */
    setTimeout(() => {
      this.showJobModal = true;
      this.job = job;
      // Object.assign(this.job, job);

      this.dashboardStore._selectJob.next(this.job);
      this.jobsService.setSelectedJob.next(job.uuid);

      this.cdr.detectChanges();

      // job["selected"] = true;
      // this.cdr

      // changes the route without moving from the current view or
      // triggering a navigation event
      if (this.job.uuid.length > 10) {
        if (this.route.snapshot.fragment == "jobsTab") {
          this.router.navigate([], {
            queryParams: {
              job: this.job.uuid,
            },
            preserveFragment: true,
            queryParamsHandling: "merge",
          });
          this.jobsService.jobChanged.next(null);
        }
      }
    }, 150);
  }

  newJob() {
    this.jobsStore.jobs[this.jobsStore.activeTab].forEach((j) => {
      j["selected"] = false;
    });

    this.job = new Job({
      client_company: this._company.id,
      task_groups: [],
      recurrence_options: {
        adjust_start_date: 0,
        weekly_weeks: 0,
        monthly_day: 0,
      },
      target_start_date: moment(new Date()),
      due_date: moment(new Date(), "MM-DD-YYYY"),
    });

    this.jobsService.setSelectedJob.next(this.job.uuid);
    this.dashboardStore._selectJob.next(this.job);

    this.job.assigned_to = this.localStorage.get("user");

    this.job["selected"] = true;
    this.jobsStore.jobs[this.jobsStore.activeTab].push(this.job);
    this.cdr.detectChanges();
    this.showJobModal = true;
  }

  newJobTemplate() {
    this.job = new Job({
      task_groups: [new TaskGroup()],
      recurrence_options: {
        adjust_start_date: 0,
        weekly_weeks: 0,
        monthly_day: 0,
      },
      is_template: true,
    });

    this.jobsStore.jobs[this.jobsStore.activeTab].push(this.job);
    this.showJobModal = true;
  }

  loadMoreJobs(activeTab: string) {
    this.start = this.start + 25;
    this.jobsService
      .getJobsByStatus(this._company.id, activeTab, this.start, this.sortBy)
      .subscribe((res) => {
        this.jobsStore.jobs[this.jobsStore.activeTab] = this.jobsStore.jobs[
          this.jobsStore.activeTab
        ].concat(<Array<Job>>res.jobs);

        this.cdr.detectChanges();
      });
  }

  setHeaders(ev) {
    this.jobsService.setHeaders(ev);
  }

  duplicateJob() {
    this.jobsService
      .duplicateJob(this.duplicateSelectedObj.uuid, this._company.id, {}, true)
      .subscribe((res) => {
        let _job = <Job>res.job;

        this.toastr.success(res.message);
        this.jobsService.newRecurringJob.next(_job);
        this.jobsStore.changeSelectedJob.next(_job);

        this.templatesForm.reset();

        this.cdr.detectChanges();

        if (this.modalRef != null) {
          this.modalRef.hide();
        }
      });
  }

  typeaheadOnSelect(e, template) {
    this.duplicateSelectedObj = e.item;
    this.modalRef = this.modalService.show(template, {
      class: "duplicate-job-modal modal-sm",
    });
  }

  setFocusOnTemplateListInput() {
    console.log("asdf");
    setTimeout(() => {
      this.templateListInput.nativeElement.focus();
    }, 200);
  }

  hideCopyModal() {
    this.templatesForm.reset();
    this.modalRef.hide();
  }

  openCreateAIJobModal(template) {
    this.modalRef = this.modalService.show(template, {
      class: "create-ai-job-modal modal-md",
      ignoreBackdropClick: true,
      keyboard: false,
    });
  }

  createAIJob() {
    this.loading = true;

    this.jobsService
      .createAIJob(this._company.id, this.aiJobDescription)
      .subscribe((res) => {
        this.loading = false;
        this.aiJobDescription = "";
        this.toastr.success(res.message);
        this.jobsService.newRecurringJob.next(res.job);
        this.jobsStore.changeSelectedJob.next(res.job);

        this.modalRef.hide();
      });
  }

  createEmbedding() {
    this.loading = true;
    this.jobsService.generateEmbeddings(this._company.id).subscribe(
      (res) => {
        this.loading = false;
        this.toastr.success(res.message);
      },
      (err) => {
        this.loading = false;
        this.toastr.error(err.error.message);
      },
    );
  }

  openAskJobQuestionModal(template) {
    this.modalRef = this.modalService.show(template, {
      class: "create-ai-job-modal modal-md",
    });
  }

  askJobQuestion() {
    this.jobsService
      .askJobQuestion(this._company.id, this.jobQuestion)
      .subscribe((res) => {
        this.jobAnswer = res.answer;
      });
  }

  changeSortBy(sortBy: string, sortByLabel: string) {
    this.sortBy = sortBy;
    this.sortByLabel = sortByLabel;
    this.loading = true;
    this.jobsService
      .getJobsByStatus(
        this._company.id,
        this.jobsStore.activeTab,
        this.start,
        sortBy,
        this.jobsStore.jobs[this.jobsStore.activeTab].length,
      )
      .subscribe((res) => {
        this.jobsStore.jobs[this.jobsStore.activeTab] = <Array<Job>>res.jobs;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  closeJobDrawer() {
    this.showJobModal = false;
    this.job = null;

    this.cdr.detectChanges();
  }

  getEmails() {
    this.emailsLoading = true;
    this.accountantService.get_company_emails(this._company.uuid).then(
      (res) => {
        this.emails = res;
        this.emailsLoading = false;
        this.cdr.detectChanges();
      },
      (err) => {
        this.emailsLoading = false;
        console.log(err);
      },
    );
  }

  togglePanel(panel: string): void {
    if (panel === "jobs") {
      this.isPanelJobsHidden = !this.isPanelJobsHidden;
    } else if (panel === "email") {
      this.isPanelEmailHidden = !this.isPanelEmailHidden;
    }
  }
}
